import styled, { css } from 'styled-components'
import { SortDirection } from '@tanstack/react-table'

type StyledTogglerProps = {
  direction: false | SortDirection
}

export const Button = styled.button`
  all: unset;
  cursor: pointer;
  padding: 0 5px;

  display: flex;
  align-items: center;
  column-gap: 5px;
`

export const ToggleIcon = styled.svg<StyledTogglerProps>`
  width: 16px;
  height: 16px;

  transition: all 0.4s;

  ${({ direction }) => {
    switch (direction) {
      case 'asc':
        return css`
          transform: rotate(180deg);
        `
      default:
        return css``
    }
  }}
`
